import { render } from "./UiAlert.vue?vue&type=template&id=c9bbd064"
import script from "./UiAlert.vue?vue&type=script&lang=js"
export * from "./UiAlert.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__